module.exports = __webpack_public_path__ + "static/media/totalZmcReq.ef028d0a.svg";